export function deleteCookie(name: string): void {
  if (typeof name !== 'string' || name.length === 0) {
    return
  }

  document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`
}
